import {
  DocumentAttachment,
  RequestComment,
  DocumentCategory,
  EntityType,
} from '@/types/domain';

export const DOCUMENT_POLICY = {
  maxFileSizeMb: 10,
  maxTotalRequestSizeMb: 50,
  maxFilesPerRequest: 10,
  commentMaxLength: 5000,
  allowedExtensions: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.png', '.jpg', '.jpeg'],
  allowedMimeTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/png',
    'image/jpeg',
  ],
} as const;

export interface IDocumentCommentService {
  getDocuments(entityType: EntityType, entityId: string): Promise<DocumentAttachment[]>;
  uploadDocument(
    entityType: EntityType,
    entityId: string,
    file: File,
    category: DocumentCategory
  ): Promise<DocumentAttachment>;
  downloadDocument(documentId: string): Promise<{ downloadUrl: string; fileName: string }>;
  deleteDocument(documentId: string): Promise<boolean>;

  getComments(entityType: EntityType, entityId: string): Promise<RequestComment[]>;
  createComment(
    entityType: EntityType,
    entityId: string,
    commentText: string,
    attachmentIds?: string[],
    isClarification?: boolean
  ): Promise<RequestComment>;
  updateComment(commentId: string, commentText: string): Promise<RequestComment>;
  deleteComment(commentId: string): Promise<boolean>;
}
